import React, { FunctionComponent, ReactNode } from 'react';

export const ErrorAlert: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
	<div className='form-error'>
		<h1>{children}</h1>
	</div>
);

ErrorAlert.displayName = 'UI.ErrorAlert';
